module.exports = __webpack_public_path__ + "img/kaddro01.b2a0aced.png";